<section class="full">
    <router-outlet></router-outlet>
</section>
